export const STORE_SETTINGS_REDUX_FORM = 'storeSettings';
export const ORDERS_AUTHORIZATION_SETTINGS_REDUX_FORM = 'ordersSettingsForm';
export const PULL_FROM_INVENTORY_REDUX_FORM = 'pullFromInventoryAddress';
export const PAYMENT_DETAILS_FORM = 'paymentDetailsBillingAddressForm';